var _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSbBrandGradient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 0,
    height: 0
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sb-brand-gradient_svg__fill",
    gradientTransform: "rotate(-60 .5 .5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    className: "sb-brand-gradient_svg__start-color"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    className: "sb-brand-gradient_svg__end-color"
  })))));
}

export default SvgSbBrandGradient;